module.exports = __webpack_public_path__ + "static/img/location.2d7aa9ad.svg";